import React from "react";
import { useTheme } from "@mui/material";
import { LineChart } from "../../../../../shared/components/charts";
import { brandColors } from "../../../../../theme/brandColors";
import type { DerivedMetricKey, FatigueTrendPoint } from "../data/types";

interface FatigueTrendChartProps {
  data: FatigueTrendPoint[];
  /** Which derived metrics to plot. Defaults to all four. */
  metrics?: DerivedMetricKey[];
  height?: number;
}

const META: Record<DerivedMetricKey, { label: string; color: string }> = {
  fed: { label: "FED", color: brandColors.recoverPink },
  lrm: { label: "LRM", color: brandColors.performOrange },
  cdi: { label: "CDI", color: brandColors.fuelIndigo },
  pdc: { label: "PDC", color: brandColors.focusLilac },
};

/** Multi-series trend of the PEAK4-derived indicators over time. */
export const FatigueTrendChart: React.FC<FatigueTrendChartProps> = ({
  data,
  metrics = ["fed", "lrm", "cdi", "pdc"],
  height = 300,
}) => {
  useTheme();
  const series = metrics.map((key) => ({
    dataKey: key,
    label: META[key].label,
    color: META[key].color,
  }));

  return (
    <LineChart
      data={data as unknown as Record<string, string | number | null | undefined>[]}
      xAxisKey="period"
      series={series}
      height={height}
      yAxisMin={0}
    />
  );
};
